// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"0af59a64","221":"1ae449b9","453":"64aababc","728":"ec615d86","858":"6f484578"}[chunkId] + ".chunk.js";
};